import * as Highcharts from 'highcharts';
import * as jQuery from 'jquery';
import * as numeral from 'numeral';
import * as _ from 'underscore';

import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NguCarousel, NguCarouselConfig, NguCarouselStore } from '@ngu/carousel';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { CTVNetwork } from '../ctv-featured-networks/ctv-featured-networks.component';
import { PrerollCreativeV3Component } from '../preroll-creative-v3/preroll-creative-v3.component';

@Component({
	selector: 'app-ctv-creative-detail-v3',
	styleUrls: ['./ctv-creative-detail-v3.component.css'],
	templateUrl: './ctv-creative-detail-v3.component.html'
})
export class CtvCreativeDetailV3Component extends PrerollCreativeV3Component implements OnInit {
	@Input() tertiarykey;
	@Input() colorsconfig: any;
	@Input() key: string;
	@Input() chartconfiguration: any;

	public colorPalette: ColorPalette;
	public reloadSubscription: any;
	public widgetDataSubscription: any;
	public chartConfig: any;
	public chartObj: any;

	public daypartChartObjArray: any[] = [];
	public showLoad = true;
	public hasData = true;

	public downloadconfig: any;
	public carouselOne: NguCarouselConfig;
	public featuredNetworks: CTVNetwork[] = [];
	public downloadConfiguration: DownloadConfig;
	public hasFeaturedData = false;
	public hasDaypartData = false;
	public featureLoad = false;
	public timezone: string = '';

	@ViewChild('carousel') carousel: NguCarousel<any>;
	@ViewChild('chartElement', { static: true }) chartElement: ElementRef;

	constructor(
		protected analyticalService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected colorUtilityService: ColorUtilityService
	) {
		super(analyticalService, analyticsDataModel, cdr);
		this.carouselOne = {
			grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
			loop: true,
			point: {
				hideOnSingleSlide: true,
				visible: true
			},
			touch: true,
			velocity: 0.2
		};
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.hasData = false;
			this.showLoad = true;
			this.featureLoad = true;
			this.hasFeaturedData = false;
			this.hasDaypartData = false;
			this.requestData();
			this.requestDaypartData();
		});
	}

	ngOnInit(): void {
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.hasData = false;
		this.showLoad = true;
		this.requestData();
		this.chartConfig = JSON.parse(decodeURI(this.chartconfiguration));
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.featureLoad = true;
		this.hasFeaturedData = false;
		this.hasDaypartData = false;
		this.requestDaypartData();
	}

	ngAfterViewInit(): void {}

	processDaypartResponseData(data: any): void {
		this.daypartChartObjArray = this.buildDayPartChartCollatorByFields(data);
		this.daypartChartObjArray[0].chartObj.map((chartData, index) => {
			if (chartData.dayparttime) {
				chartData.color = this.getColorFromColorConfig(index, 1);
			}
		});
		this.drawDonutChart();
	}

	buildDayPartChartCollatorByFields(daypartResponseData: any): any[] {
		const fieldChartArray: any[] = [];
		const chartObjArray: any[] = [];
		const daypartData: any = {};
		for (let index = 0; index < daypartResponseData.length; index++) {
			const chartObj: any = {};
			chartObj.name = daypartResponseData[index].daypart;
			chartObj.dayparttime = daypartResponseData[index].friendly_name;
			chartObj.y = Number(daypartResponseData[index].impressions);
			// chartObj.displayOrder = (this.displayOrder[daypartResponseData[i].daypart]) ? this.displayOrder[daypartResponseData[i].daypart] : 9;
			chartObj.displayOrder = daypartResponseData[index].display_order || index;
			chartObjArray.push(chartObj);
		}
		daypartData.chartObj = _.sortBy(chartObjArray, 'displayOrder');
		fieldChartArray.push(daypartData);
		return fieldChartArray;
	}

	requestDaypartData(): void {
		this.analyticsService.processCustomServiceRequest(this.tertiarykey).subscribe((response: any) => {
			this.featureLoad = false;
			this.timezone = response && response.timezone ? `(${response.timezone})` : '';
			if (response.success) {
				if (response.data && response.data.length > 0) {
					this.hasDaypartData = true;
					this.processDaypartResponseData(response.data);
				} else {
					this.hasDaypartData = false;
				}
			} else {
				this.hasDaypartData = false;
			}
		});
	}

	processCreativesResponseData(creativesData: any): any {
		for (const creative of creativesData) {
			creative.mp4 = creative.video_url;
		}
		return creativesData;
	}

	requestData(): void {
		this.analyticsService.processCustomServiceRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				const processedData = this.processCreativesResponseData(response.data);
				this.setData(processedData);
			} else {
				this.hasData = false;
			}
		});
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
	}

	downloadFeaturedNetworkCSV(): void {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.secondarycsvQueryKey ? this.downloadConfiguration.secondarycsvQueryKey : this.key,
			this.downloadConfiguration.secondaryFileName
		);
	}
	downloadCSV(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName
		);
	}

	requestfeaturedNetworkData(): void {
		this.analyticsService.processWidgetRequest(this.tertiarykey).subscribe((response: any) => {
			this.featureLoad = false;
			if (response.success) {
				if (response.data && response.data.length > 0) {
					this.hasFeaturedData = true;
					this.processFeaturedNetworkResponseData(response.data);
				} else {
					this.featuredNetworks = [];
					this.hasFeaturedData = false;
				}
			} else {
				this.hasFeaturedData = false;
			}
		});
	}

	processFeaturedNetworkResponseData(data: any): void {
		this.featuredNetworks = this.mapCTVNetworkResponseToInterface(data);
	}

	mapCTVNetworkResponseToInterface(responseArray: any[]): CTVNetwork[] {
		const ctvNetworks: CTVNetwork[] = [];
		for (const responseObj of responseArray) {
			const ctvNetwork: CTVNetwork = {} as CTVNetwork;
			ctvNetwork.networkName = responseObj.network_name;
			ctvNetwork.friendlyName = responseObj.friendly_name;
			ctvNetwork.logoPath = responseObj.logo_path;
			ctvNetwork.impressions = !UtilityService.isUndefinedOrNull(responseObj.impressions)
				? parseInt(responseObj.impressions, 10)
				: 0;
			ctvNetwork.completions = !UtilityService.isUndefinedOrNull(responseObj.completions)
				? parseInt(responseObj.completions, 10)
				: 0;
			ctvNetwork.completionRate = !UtilityService.isUndefinedOrNull(responseObj.completions_rate)
				? numeral(responseObj.completions_rate).format('0,0.00')
				: 0;
			ctvNetwork.percent25 = !UtilityService.isUndefinedOrNull(responseObj['25_percent'])
				? parseInt(responseObj['25_percent'], 10)
				: 0;
			ctvNetwork.percent50 = !UtilityService.isUndefinedOrNull(responseObj['50_percent'])
				? parseInt(responseObj['50_percent'], 10)
				: 0;
			ctvNetwork.percent75 = !UtilityService.isUndefinedOrNull(responseObj['75_percent'])
				? parseInt(responseObj['75_percent'], 10)
				: 0;
			ctvNetwork.percent100 = !UtilityService.isUndefinedOrNull(responseObj['100_percent'])
				? parseInt(responseObj['100_percent'], 10)
				: 0;
			ctvNetworks.push(ctvNetwork);
		}
		ctvNetworks.sort((a: any, b: any): any => {
			return b.completionRate - a.completionRate;
		});
		return ctvNetworks;
	}

	drawDonutChart(): void {
		this.chartObj = Highcharts.chart({
			chart: {
				renderTo: this.chartElement.nativeElement
			},
			credits: {
				enabled: false
			},
			legend: {
				align: this.chartConfig.graphConfig.legendConfig.align,
				itemDistance: this.chartConfig.graphConfig.legendConfig.itemDistance,
				itemHoverStyle: {
					color: this.chartConfig.graphConfig.legendConfig.itemHoverStyle.color,
					fontSize: this.chartConfig.graphConfig.legendConfig.itemStyle.fontSize,
					fontWeight: this.chartConfig.graphConfig.legendConfig.itemHoverStyle.fontWeight
				},
				itemMarginBottom: this.chartConfig.graphConfig.legendConfig.itemMarginBottom,
				itemStyle: {
					color: this.chartConfig.graphConfig.legendConfig.itemStyle.color,
					fontSize: this.chartConfig.graphConfig.legendConfig.itemStyle.fontSize,
					fontWeight: this.chartConfig.graphConfig.legendConfig.itemStyle.fontWeight
				},
				itemWidth: this.chartConfig.graphConfig.legendConfig.itemWidth,
				labelFormatter(): string {
					return this.name;
				},
				symbolHeight: 18,
				symbolPadding: 30,
				symbolRadius: 8,
				symbolWidth: 18,
				verticalAlign: this.chartConfig.graphConfig.legendConfig.verticalAlign,
				x: this.chartConfig.graphConfig.legendConfig.x,
				y: this.chartConfig.graphConfig.legendConfig.y
			},
			plotOptions: {
				pie: {
					borderWidth: 0,
					states: {
						inactive: {
							opacity: 1
						}
					}
				}
			},
			series: [
				{
					data: this.daypartChartObjArray[0].chartObj,
					dataLabels: {
						enabled: false
					},
					innerSize: this.chartConfig.seriesConfig[0].innerSize,
					showInLegend: true,
					size: this.chartConfig.seriesConfig[0].size,
					states: {
						hover: {
							enabled: false
						}
					},
					type: this.chartConfig.seriesConfig[0].type
				}
			],
			title: {
				text: null
			},
			tooltip: {
				backgroundColor: this.chartConfig.seriesConfig[0].tooltipInfo[0].backgroundColor,
				borderWidth: this.chartConfig.seriesConfig[0].tooltipInfo[0].borderWidth,
				followPointer: false,
				padding: this.chartConfig.seriesConfig[0].tooltipInfo[0].padding,
				shadow: this.chartConfig.seriesConfig[0].tooltipInfo[0].shadow,
				style: {
					color: this.chartConfig.seriesConfig[0].tooltipInfo[0].style.color
				},
				useHTML: true,
				formatter(): string {
					return `<div style="text-align: center; font-size: 14px">
						<div style="padding-bottom: 5px;">${this.point['dayparttime']}</div>
						<div>${numeral(this.y).format('0,0')} impressions</div>
						</div>
					`;
				}
			}
		});
	}

	protected getColorFromColorConfig(index: number, opacity?: number): string {
		const colorConfig: ColorConfig = this.colorsconfig[index];

		const fillOpacity = colorConfig ? colorConfig.opacity : opacity;
		let rgb = '';
		if (colorConfig && colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else if (colorConfig && colorConfig.color) {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}
}
